import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	creatingServiceProject: {
		id: 'projects-directory-v3.page-layout.top-banner.auto-create-project-modal.creating-service-project',
		defaultMessage: 'Creating your service project...',
		description: 'Creating your JSM project',
	},
	altImageText: {
		id: 'projects-directory-v3.page-layout.top-banner.auto-create-project-modal.alt-image-text',
		defaultMessage: 'Image showing users working on a project',
		description: 'Image showing users working on a project',
	},
	captureRequests: {
		id: 'projects-directory-v3.page-layout.top-banner.auto-create-project-modal.capture-requests',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Capture requests with email, Slack, Teams, or a central help centre.',
		description: 'Use email, Slack or Teams to capture requests',
	},
	priortiseWorkUsingQueues: {
		id: 'projects-directory-v3.page-layout.top-banner.auto-create-project-modal.priortise-work-using-queues',
		defaultMessage: 'Use queues to prioritize requests.',
		description: 'You can use queues to prioritize work.',
	},
	linkIssuesToJira: {
		id: 'projects-directory-v3.page-layout.top-banner.auto-create-project-modal.link-issues-to-jira',
		defaultMessage: 'Keep everything linked together in Jira.',
		description: 'You can keep link everything together in Jira.',
	},
});
